import { useEffect, useState, useCallback } from "react";
import { Loader2, Phone, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";

export default function Callbacks() {
  const [rows, setRows] = useState(null);

  const load = useCallback(() => api.get("/admin/callbacks/list").then((r) => setRows(r.data)).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);

  const markDone = async (id) => {
    try {
      await api.patch(`/admin/callbacks/${id}`, { status: "done" });
      toast.success("Marked as contacted");
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div data-testid="admin-callbacks-page">
      <div className="mb-6">
        <h1 className="font-heading text-2xl font-extrabold text-brand-dark">Callback Requests</h1>
        <p className="text-sm text-brand-muted mt-0.5">Each request also creates a lead in the pipeline</p>
      </div>
      {!rows ? <div className="py-20 flex justify-center"><Loader2 className="animate-spin text-brand-red" size={28} /></div> : (
        <div className="space-y-3">
          {rows.map((c) => (
            <div key={c.id} className="bg-white rounded-xl border border-black/5 p-5 flex flex-wrap items-center justify-between gap-3" data-testid={`callback-row-${c.id}`}>
              <div>
                <p className="font-heading font-bold text-brand-dark">{c.name} <span className="font-sans text-sm font-semibold text-brand-muted">· {c.phone}</span></p>
                <p className="text-xs text-brand-muted mt-1">{c.loan_type || "General"} {c.preferred_time ? `· ${c.preferred_time}` : ""} · {new Date(c.created_at).toLocaleString("en-IN")}</p>
                {c.message && <p className="text-xs text-brand-dark/70 mt-1.5">{c.message}</p>}
              </div>
              <div className="flex items-center gap-2.5">
                <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full border ${c.status === "done" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-700 border-amber-200"}`}>{c.status}</span>
                <a href={`tel:${c.phone}`} data-testid={`callback-call-${c.id}`} className="w-8 h-8 rounded-full bg-brand-cream border border-black/10 flex items-center justify-center text-brand-dark hover:border-brand-red"><Phone size={13} /></a>
                {c.status !== "done" && (
                  <button onClick={() => markDone(c.id)} data-testid={`callback-done-${c.id}`} className="w-8 h-8 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center text-emerald-600"><CheckCircle2 size={14} /></button>
                )}
              </div>
            </div>
          ))}
          {rows.length === 0 && <p className="text-center text-brand-muted text-sm py-10 bg-white rounded-xl border border-black/5">No callback requests yet.</p>}
        </div>
      )}
    </div>
  );
}
